export const getHighlighterTabs = (lastView = null, allHighlighterTabListingInfo) => {
  const {
    featuredListings,
    featuredProjects,
    jetOpportunities,
    rentLandPriceDownListings,
    rentPriceDownListings,
    saleLandPriceDownListings,
    salePriceDownListings,
  } = allHighlighterTabListingInfo || {};

  const tabListings = [
    {
      tabName: "Öne Çıkan İlanlar",
      tabKey: "featuredListings",
      tabTitle: "Emlak ofislerinin öne çıkan ilanlarını keşfet!",
      getListings: featuredListings,
      badgeKey: "promotion",
      eventLabel: "one-cikanlar",
      seeAllListingHref: "/vitrin",
      isVisible: lastView !== "Arsa",
    },
    {
      tabName: "Jetfırsat",
      tabKey: "jetOpportunityListings",
      tabTitle: "Hesabını bilene kaçırılmayacak fırsatlar burada!",
      getListings: jetOpportunities,
      badgeKey: "opportunity",
      eventLabel: "jetfirsat",
      seeAllListingHref: "/satilik-konut?fiyat_analizi=firsat",
      isVisible: lastView !== "Arsa",
    },
    {
      tabName: "Fiyatı Düşen Satılıklar",
      tabKey: "priceDownSaleListings",
      tabTitle:
        lastView === "Arsa"
          ? "Satılık Arsa mı arıyorsun? Fiyatı düşen satılık arsaları gözden geçir."
          : "Satılık ev mi arıyorsun? Fiyatı düşen satılıkları gözden geçir.",
      getListings: lastView === "Arsa" ? saleLandPriceDownListings : salePriceDownListings,
      badgeKey: "price-down",
      eventLabel: "fiyati-dusen-satiliklar",
      seeAllListingHref: `/satilik-${lastView === "Arsa" ? "arsa" : "konut"}?fiyat_trendi=dusen`,
      isVisible: true,
    },
    {
      tabName: "Fiyatı Düşen Kiralıklar",
      tabKey: "priceDownRentListings",
      tabTitle: `Hesabını bilene fiyatı düşen ${lastView === "Arsa" ? "kiralık arsalar" : "kiralıklar"} burda!`,
      getListings: lastView === "Arsa" ? rentLandPriceDownListings : rentPriceDownListings,
      badgeKey: "price-down",
      eventLabel: "fiyati-dusen-kiraliklar",
      seeAllListingHref: `/kiralik-${lastView === "Arsa" ? "arsa" : "konut"}?fiyat_trendi=dusen`,
      isVisible: true,
    },
    {
      tabName: "Öne Çıkan Projeler",
      tabKey: "featuredProjectListings",
      tabTitle: "Emlakjet’e özel konut projelerini keşfet!",
      getListings: featuredProjects,
      badgeKey: "",
      eventLabel: "one-cikan-projeler",
      seeAllListingHref: "/satilik-konut/projeler",
      isVisible: lastView !== "Arsa",
    },
  ];

  const tabNames = tabListings.reduce((list, tab) => {
    if (tab.isVisible) {
      list.push({
        tabName: tab.tabName,
        tabKey: tab.tabKey,
        ga4Event: tab.eventLabel,
      });
    }
    return list;
  }, []);

  return {
    tabListings,
    tabNames,
  };
};
